import React, {Component} from 'react';
import Styles from './style.css';
import {BeatLoader} from 'react-spinners';
import cx from "classnames";
import {cartRegister} from "../../services/cartRegister";
import {dataRegister} from "../../services/dataRegister";
import {langRegister} from "../../services/langRegister";
import ReactGA from 'react-ga';
import ReactGA4 from 'react-ga4';
import ReactPixel from "react-facebook-pixel";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import ErrorHandler from "../../components/error-handler/component";
import {imagesRegister} from "../../services/imagesRegister";
import {quotesRegister} from "../../services/quotesRegister";
import Information from "../../components/information/component";
import BoosterHeader from "../../components/booster-header/component";
import {scraperRegister} from "../../services/scraperRegister";

class BoosterCrossRoad extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            selected: "custom"
        };
    };

    componentWillMount() {
        window.scrollTo(0, 0);

        //GOOGLE ANALYTICS
        if(dataRegister.api.primehit !== "https://api.devprimehit.com/v1"){
            ReactGA.pageview('/booster/crossroad');
        }

        //FACEBOOK PIXEL
        if(dataRegister.api.primehit !== "https://api.devprimehit.com/v1"){
            ReactPixel.pageView();
        }

        this.update.data();
    };

    update = {
        data: () => {
            let cart = cartRegister.get();
            let scraper_data = JSON.parse(scraperRegister.get());
            try{
                if(scraper_data.images.length < 1){
                    this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang()+ "/booster/industry?crossroad=custom")
                }else{
                    this.setState({
                        isLoading: false,
                        selected: cart.crossroad?cart.crossroad:"custom"
                    });
                }
            }catch (e) {
                this.setState({
                    isLoading: false,
                    selected: cart.crossroad?cart.crossroad:"custom"
                });
            }
        }
    };

    functions = {
        set: (value) => {
            let storage = cartRegister.getCheckout();
            if(storage.crossroad !== value){
                cartRegister.remove();
                quotesRegister.remove();
                imagesRegister.remove();
                if(storage.options){
                    cartRegister.setOptions(storage.options);
                }
                cartRegister.setCrossRoad(value);
                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang()+ "/booster/industry?crossroad="+value)
            }else{
                cartRegister.setCrossRoad(value);
                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/industry?crossroad="+value)
            }
        },
        back: () => {
            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/options")
        }
    };

    renders = {
        text: (item) => {
            return langRegister.get("booster-crossroad", item);
        }
    };

    render() {
        return (
            <div>
                <BoosterHeader props={this.props}/>
                {
                    !this.state.isLoading && !this.state.error &&
                    <div className={Styles.container}>
                        <div className={Styles.title}>
                            <div>
                                {this.renders.text("item_1")}
                            </div>
                        </div>
                        <div className={Styles.optionsContainer}>
                            <div className={Styles.optionsContainerItem}>
                                <div className={Styles.optionsContainerItemInner}>
                                    <div onClick={() => this.functions.set("custom")} className={
                                        cx(Styles.optionsContainerItemInnerLayer,
                                            {
                                                [Styles.optionsContainerItemInnerLayerSelected]: this.state.selected === "custom",
                                            })
                                    }>
                                        <div className={Styles.optionsContainerItemInnerTitle}>
                                            {this.renders.text("item_4")}<br/>{this.renders.text("item_5")}
                                        </div>
                                        {
                                            false &&
                                            <div className={Styles.optionsContainerItemInnerSubtitle}>
                                                {this.renders.text("item_14")}
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className={Styles.optionsContainerItem}>
                                <div className={Styles.optionsContainerItemInner}>
                                    <div onClick={() => this.functions.set("auto")} className={
                                        cx(Styles.optionsContainerItemInnerLayer,
                                            {
                                                [Styles.optionsContainerItemInnerLayerSelected]: this.state.selected === "auto",
                                            })
                                    }>
                                        <div className={Styles.optionsContainerItemInnerTitle}>
                                            {this.renders.text("item_2")}<br/>{this.renders.text("item_3")}
                                        </div>
                                        {
                                            false &&
                                            <div className={Styles.optionsContainerItemInnerSubtitle}>
                                                {this.renders.text("item_10")}
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        {
                            <div onClick={() => this.functions.back()} className={Styles.backButton}>
                                {"< back"}
                            </div>
                        }
                    </div>
                }
                {
                    this.state.isLoading &&
                    <div className={Styles.loader}>
                        <BeatLoader size={30} color={'var(--first-color)'} loading={true}/>
                    </div>
                }
            </div>
        );
    }
}

export default BoosterCrossRoad;


// WEBPACK FOOTER //
// ./src/pages/booster-crossroad/component.js